﻿/*
 * @class rlFixedCTA
 * @memberOf jQuery.fn
 */

(function ($) {
    $.fn.rlFixedCTA = function () {

        var myElement = document.querySelector("#main-content div.container div.row");
        var position;

        window.addEventListener("resize", FixedPosition, false);

        function FixedPosition() {
            position = getPosition(myElement);
            $('.fixed-cta-btn').css('left', position.x - 5);
            //- 5 to allow for padding on the BS4 .row elements
        }

        // helper function to get the querySelector X position
        function getPosition(el) {
            var xPosition = 0;
            while (el) {
                if (el.tagName == "BODY") {
                    var xScrollPos = el.scrollLeft || document.documentElement.scrollLeft;
                    xPosition += (el.offsetLeft - xScrollPos + el.clientLeft);
                }
                else {
                    xPosition += (el.offsetLeft - el.scrollLeft + el.clientLeft);
                }
                el = el.offsetParent;
            }
            return {
                x: xPosition
            };
        }

        FixedPosition();
        
    }
}(jQuery));